import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";

const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const Table = styled.table`
  width: 98%;
  background-color: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    display: block;
  }
`;

const TdButton = styled.td`
  font-size: 16px;
  font-weight: bold;
  word-break: break-word;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  color: #575757;
  text-align: center;
  &:hover {
    transform: scale(1.3);
      
  }
  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: flex;
    justify-content: center;
    padding: 5px 0;
    font-size: 14px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: 5px 0px;
    padding: 10px 0px;
    &::before {
      content: attr(data-label); /* Exibe o cabeçalho como rótulo no layout de cards */
      font-weight: bold;
      margin-right: 10px;
    }
  }
`;

const Thead = styled.thead`
  @media (max-width: 768px) {
    display: none;
  }
`;

const Tbody = styled.tbody`
  padding-bottom: 25px; 

  @media (max-width: 768px) {
    display: block; /* Torna cada linha um card */
  }
`;

const Tr = styled.tr`
  text-align: center;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
  }
`;


const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: none; /* Oculta cabeçalhos no layout de cards */
  }
`;


const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: start;
  width: auto;

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 8px 0;
    width: auto;
    &::before {
      content: attr(data-label);
      font-weight: bold;
      color: #333;
      margin-right: 10px;
    }
  }
`;

export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;


`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
`;

const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0px;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Input = styled.input`
  width: 345px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;


`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;


const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;

const Grid = ({ usuarios, modalEditarUsuario }) => {


  //---------------------------------------MODAL PARA EDITAR O USUÀRIO---------------------------------------------------//
  const handleEdit = (item) => {
    modalEditarUsuario(item);
  };


  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(usuarios);
  const [isLoading, setIsLoading] = useState(true);

  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = usuarios.filter((user) => {
        const cracha = (user.COD_FUNCIONARIO || '').toString().toLowerCase();
        const login = (user.LOGON || '').toLowerCase();
        const nome = (user.NOME || '').toLowerCase();



        return (
          cracha.includes(term.toLowerCase()) ||
          login.includes(term.toLowerCase()) ||
          nome.includes(term.toLowerCase())
        );
      });
      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }
    setCurrentPage(1);
    setIsLoading(false);
  };


  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, usuarios]);




  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };


  return (

    <Container>
      <Td3 colSpan="7">
        <Input
          type="text"
          placeholder="Pesquisar... Ex: crachá, login ou nome"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <Div>
          <Button onClick={handlePrevPage} disabled={currentPage === 1}>
            <ImArrowLeft size={20} />
          </Button>
          <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
            <ImArrowRight size={20} />
          </Button>
        </Div>
      </Td3>
      <Table >
        <Thead>

          <Tr>
            <Th onClick={() => onColumnClick("COD_FUNCIONARIO")} className={getSortClass("COD_FUNCIONARIO")}>
              Crachá: {getSortIcon("COD_FUNCIONARIO")}
            </Th>
            <Th onClick={() => onColumnClick("LOGON")} className={getSortClass("LOGON")}>
              Login: {getSortIcon("LOGON")}
            </Th>
            <Th onClick={() => onColumnClick("NOME")} className={getSortClass("NOME")}>
              Nome: {getSortIcon("NOME")}
            </Th>
            <Th onlyWeb></Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.map((item, i) => (
            <Tr key={i}>
              <Td width="auto">{item.COD_FUNCIONARIO}</Td>
              <Td width="auto">{item.LOGON}</Td>
              <Td width="auto">{item.NOME}</Td>
              <Td >
                <TdButton width="auto" onClick={() => handleEdit(item)}>
                  Editar
                </TdButton>
              </Td>

            </Tr>
          ))}
        </Tbody>


      </Table>

    </Container>
  );
};


export default Grid;
